import OrgSettingsView from '@/org-settings/OrgSettingsView.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {usePanelManager} from '@tritt/multipanel'
import OrgSettingsCrumbs from '@/org-settings/OrgSettingsCrumbs.vue'
import {h} from 'vue'
import {NavGroup, registerNavigationEntry} from '@/navigation'

export const ORG_SETTINGS = {
    componentName: 'OrgSettings',
    component: OrgSettingsView,
    meta: {
        requiresOrg: true,
    }
}
const {registerNavigationCommand} = useContaCommand()
const {registerBreadCrumbGetter} = useBreadCrumbs()
const icon = 'i-ph-wrench'
const label = 'Virksomhetsinnstillinger'

const tabs = [{path: 'general', label: 'Generelt', icon: 'i-ph-gear'},
    {path: 'ehf', label: 'EHF', icon: 'i-ph-envelope-open'},
    {path: 'patron', label: 'Bilagsmottak', icon: 'i-ph-envelope-simple'},
    {path: 'bank', label: 'Bank', icon: 'i-ph-bank'},
    {path: 'approvalflow', label: 'Godkjenningsflyt', icon: 'i-ph-check-square'},
    {path: 'debtCollection', label: 'Purring og inkasso', icon: 'i-ph-hammer'},
]

registerNavigationCommand({
    route: ORG_SETTINGS,
    label,
    icon
})


tabs.forEach((path: { path: string, label: string, icon: string }, sortOrder: number) => {
    registerNavigationEntry(NavGroup.ORGANIZATION, {
        title: path.label,
        key: `org-settings-${path.path}`,
        icon: path.icon,
        target: {
            ...ORG_SETTINGS,
            queryValues: {tab: path.path}
        },
        sortOrder
    })
})

registerRoute(ORG_SETTINGS)
registerBreadCrumbGetter(() => {
    const {currentPanelContent} = usePanelManager()
    if (currentPanelContent.value?.componentName !== ORG_SETTINGS.componentName) {
        return
    }
    return h(OrgSettingsCrumbs, {panelContent: currentPanelContent.value})
})

